export default __webpack_public_path__ + "static/tag-do-2-light-861ede958bb13cf2cdf3eab96ac64ca92ff1669e9bc436aa545524e8dcdb3e54.png";